export const api_activities_errors = {
  updateManyErrors: (type: "organization" | "medCenter") => ({
    api: `/api/v1/systemManager/mistakes/?type=${type}`,
    method: "PATCH"
  }),
  updateOneErrors: (mistakeId, patientId) => ({
    api: `/api/v1/systemManager/mistakes/${mistakeId}/patients/${patientId}`,
    method: "PATCH"
  }),

}